import { gql, useQuery } from '@apollo/client'

import { TYPE } from 'features/Inventories/components/Type/constants'

export const GET_SUPPLIERS_AUTOCOMPLETE = gql`
  query GetSuppliersAutocomplete($companyId: ID) {
    suppliersAutocomplete(input: { limit: 100000, companyID: $companyId }) {
      name
    }
  }
`

export const GET_INVENTORIES_AUTOCOMPLETE = gql`
  query GetInventoriesAutocomplete($companyId: ID, $types: [InventoryAutocompleteType!]) {
    inventoriesAutocomplete(input: { limit: 100000, companyID: $companyId, types: $types }) {
      id
      name
      type
    }
  }
`

export const sanitizeInventory = (inventoryId: TSFixMe, companyId: TSFixMe): TSFixMe => {
  let inventory
  const { data: inventoriesData } = useQuery(GET_INVENTORIES_AUTOCOMPLETE, {
    skip: !inventoryId || !companyId,
    variables: {
      companyId
    }
  })

  if (inventoriesData && inventoriesData.inventoriesAutocomplete) {
    inventory = inventoriesData.inventoriesAutocomplete.find(({ id }: TSFixMe): TSFixMe => inventoryId === id)
  }

  return inventory
}

export const getDestinationInventoryType = (inventory: TSFixMe): TSFixMe => {
  if (inventory.type === TYPE.WAREHOUSE) {
    return [TYPE.WAREHOUSE, TYPE.BASE]
  }

  if (inventory.type === TYPE.BASE) {
    return [TYPE.WAREHOUSE, TYPE.BASE, TYPE.CART]
  }

  if (inventory.type === TYPE.CART) {
    return [TYPE.BASE, TYPE.CART]
  }

  return []
}
